import { render, staticRenderFns } from "./ServiceFees.vue?vue&type=template&id=f8c90a46&scoped=true"
import script from "./ServiceFees.vue?vue&type=script&lang=js"
export * from "./ServiceFees.vue?vue&type=script&lang=js"
import style0 from "./ServiceFees.vue?vue&type=style&index=0&id=f8c90a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c90a46",
  null
  
)

export default component.exports